import type { UserFollowedLeader, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';
import type { FindById, FindByIdThrows } from '../findById';

/**
 * @deprecated PERFORMANCE This selects an entity object, which will return a new instance and force re-renders
 * when changed. This should be replaced by a `getUserFollowedLeadersField` selector.
 */
export const findById: FindById<'userFollowedLeaders'> = createFindById('userFollowedLeaders');
/**
 * @deprecated PERFORMANCE This selects an entity object, which will return a new instance and force re-renders
 * when changed. This should be replaced by a `getUserFollowedLeadersFieldThrows` selector.
 */
export const findByIdThrows: FindByIdThrows<'userFollowedLeaders'> = createFindByIdThrows('userFollowedLeaders');

type GetFulfilledUserFollowedLeaders = (state: YammerState) => Record<string, UserFollowedLeader>;
/**
 * @deprecated PERFORMANCE This return an object of all fulfilled entities, which will return a new object instance
 * and force consumers to re-render whenever ANY entity gets updated in the store. This selector should be deleted.
 */
export const getFulfilledUserFollowedLeaders: GetFulfilledUserFollowedLeaders = (state) =>
  state.userFollowedLeaders.fulfilled.byId;
